export type HumanInteractionClass = 'weak' | 'strong';

const STRONG_HUMAN_KINDS = new Set(['click', 'keydown', 'touchstart']);

export function interactionClass(kind: unknown): HumanInteractionClass {
  return STRONG_HUMAN_KINDS.has(String(kind ?? '').trim().toLowerCase()) ? 'strong' : 'weak';
}

export function interactionDedupeKey(
  sessionId: string,
  pagePath: string,
  eventName: string,
  meta?: Record<string, unknown>,
): string {
  const base = `${sessionId}:${pagePath}:${eventName}`;
  return eventName === 'human_interaction' ? `${base}:${interactionClass(meta?.kind)}` : base;
}
